import { StyleSheet } from 'react-native'

export default StyleSheet.create({
    cardStyle: {
        marginHorizontal: 16,
        marginTop: 32,
        marginBottom: 0,
        padding: 0,
    },
    cardContentContainer: {
        paddingVertical: 0,
        borderWidth: 0,
    },
})
